export enum DetailValueType {
    DateTime = "DateTime",
    Double = "Double",
    Integer = "Integer",
    Text = "Text"
}